var _window, _window$LIFE_CYCLE_EV, _window3, _window3$LIFE_CYCLE_E;

import React from 'react';
import { READY } from '../utils/constants.js';
import { createClickId } from '../utils/index.js';
export const impressionGlobalData = {
  observer: null,
  impressionMap: new Map(),
  impressed: {},
  impressionRefArray: []
};

// re-observe items for impressions on visibility change
if (typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && (_window$LIFE_CYCLE_EV = _window.LIFE_CYCLE_EVENT_BUS) !== null && _window$LIFE_CYCLE_EV !== void 0 && _window$LIFE_CYCLE_EV.lifeCycle) {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('page.visibilitychange', () => {
    var _window2, _window2$__EXPERIENCE;
    if (!document.hidden && (_window2 = window) !== null && _window2 !== void 0 && (_window2$__EXPERIENCE = _window2.__EXPERIENCE_CONTEXT__) !== null && _window2$__EXPERIENCE !== void 0 && _window2$__EXPERIENCE.isConsumerApp) {
      var _impressionGlobalData;
      impressionGlobalData.impressed = {};
      if (((_impressionGlobalData = impressionGlobalData.impressionRefArray) === null || _impressionGlobalData === void 0 ? void 0 : _impressionGlobalData.length) > 0) {
        for (let i = 0; i < impressionGlobalData.impressionRefArray.length; i += 1) {
          const entry = impressionGlobalData.impressionMap.get(impressionGlobalData.impressionRefArray[i]);
          // Reset the visibility timer to zero and re-observe each entry
          const clickID = createClickId({
            data: entry.impression,
            parent: entry.container
          });
          // Why is this NOT an empty string?
          impressionGlobalData.impressed[clickID] = READY;
          entry.visibleSince = 0;
          clearTimeout(entry.timeout);
          impressionGlobalData.observer.observe(entry.ref);
        }
      }
    }
  });
}

// on-event driven reset of impression provider
if (typeof window !== 'undefined' && (_window3 = window) !== null && _window3 !== void 0 && (_window3$LIFE_CYCLE_E = _window3.LIFE_CYCLE_EVENT_BUS) !== null && _window3$LIFE_CYCLE_E !== void 0 && _window3$LIFE_CYCLE_E.lifeCycle) {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('resetImpressionProvider', () => {
    var _impressionGlobalData2;
    impressionGlobalData.impressed = {};
    if (((_impressionGlobalData2 = impressionGlobalData.impressionRefArray) === null || _impressionGlobalData2 === void 0 ? void 0 : _impressionGlobalData2.length) > 0) {
      for (let i = 0; i < impressionGlobalData.impressionRefArray.length; i += 1) {
        const entry = impressionGlobalData.impressionMap.get(impressionGlobalData.impressionRefArray[i]);
        const clickID = createClickId({
          data: entry.impression,
          parent: entry.container
        });
        // Why is this an empty string?
        impressionGlobalData.impressed[clickID] = '';
        entry.visibleSince = 0;
        clearTimeout(entry.timeout);
        impressionGlobalData.observer.observe(entry.ref);
      }
    }
  });
}
const defaultContextValue = {
  ref: null,
  clickID: null,
  parent: {
    id: '',
    // *** required prop ***
    component: '',
    // *** required prop *** ==> component public export name
    name: 'Page',
    // *** required prop *** descriptive titles or component name
    variation: '',
    // cta style values
    position: '',
    type: '',
    category: ''
  },
  data: {
    id: '',
    // *** required prop ***
    component: '',
    // *** required prop *** ==> component public export name
    name: 'component',
    // *** required prop *** ==> descriptive titles or component name
    variation: 'component',
    // cta style values
    position: '',
    type: '',
    category: ''
  },
  additionalData: {}
};
export const ImpressionContext = /*#__PURE__*/React.createContext(defaultContextValue);
//# sourceMappingURL=ImpressionContext.js.map